import { Richiedente, SectionVM } from 'civil-status/view-models/step-form';

export const transformerRichiedente = (
  idEvento?: number,
  dataSection?: SectionVM
): Richiedente | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: {
      idEvento,
    },
    tipoRichiedente: dataSection.typeApplicant || undefined,
  };
};
